import React from "react";
import { TrendingUp, TrendingDown, Users, Zap, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";

export interface StationPerformance {
  station_id: string;
  station_name: string;
  total_sessions: number;
  consumed_kwh: number;
  total_revenue: number;
  avg_revenue_per_session: number;
  total_chargers: number;
  active_chargers: number;
}

interface StationCardListProps {
  stations: StationPerformance[];
}

const StationCardList: React.FC<StationCardListProps> = ({ stations }) => {
  const navigate = useNavigate();

  const getStatusClass = (activeChargers: number) => {
    if (activeChargers > 0) return "status-online";
    return "status-maintenance";
  };
  const handleViewDetails = (stationId: string) => {
    navigate(`/stations/${stationId}`);
  };
  return (
    <div className="station-card-list">
      {stations.map((station) => {
        const isRevenuePositive = station.total_revenue >= 0;

        return (
          <div key={station.station_id} className="card station-detail-card">
            <div className="card-top-section">
              <div className="info-block">
                <h3 className="station-name">{station.station_name}</h3>
                <span
                  className={`status-tag ${getStatusClass(
                    station.active_chargers
                  )}`}
                >
                  {station.active_chargers > 0 ? "Online" : "Maintenance"}
                </span>

                <p className="location-chargers">
                  {station.total_chargers} total | {station.active_chargers}{" "}
                  active chargers
                </p>
              </div>

              <div className="revenue-block">
                <p className="revenue-value">
                  ₹
                  {station.total_revenue != null
                    ? station.total_revenue.toLocaleString()
                    : "0"}
                </p>

                <p className="revenue-label">Total Revenue</p>
                {/* <span
                  className={`revenue-change ${
                    isRevenuePositive ? "positive" : "negative"
                  }`}
                >
                  {isRevenuePositive ? (
                    <TrendingUp size={14} />
                  ) : (
                    <TrendingDown size={14} />
                  )}
                </span> */}
              </div>
            </div>

            <div className="card-bottom-section">
              <div className="station-metrics-grid">
                <div className="metric-item">
                  <p className="metric-label">Sessions</p>
                  <Users size={18} />
                  <p className="metric-value">{station.total_sessions}</p>
                </div>

                <div className="metric-item">
                  <p className="metric-label">Energy</p>
                  <Zap size={18} />
                  <p className="metric-value">
                    {/* {station.consumed_kwh.toFixed(2)} kWh */}
                    {station?.consumed_kwh != null
                      ? station?.consumed_kwh.toFixed(2).toLocaleString()
                      : "0"}{" "}
                    kWh
                  </p>
                </div>

                {/* <div className="metric-item">
                  <p className="metric-label">Avg Time</p>
                  <Clock size={18} />
                  <p className="metric-value">{station.avgTime}</p>
                </div> */}
                {/* <div className="metric-item">
                <p className="metric-label">Utilization</p>
                <Users size={18} />
                <p className="metric-value">{station.utilization}</p>
              </div> */}
              </div>

              {/* <div className="tooltip-wrapper"> */}
              <button
                className="view-details-btn"
                onClick={() => handleViewDetails(station.station_id)}
              >
                View details
              </button>
              {/* </div> */}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StationCardList;
